import type { PassportPageSummary } from "@peer-start/platform-contracts";
import { Card, CardHeader, ProgressRing } from "@peer-start/ui";
import { useTranslation } from "react-i18next";
import { CompetencyBars } from "./LearningRouteProgress.js";

export function RouteOverviewProgress({
  overview,
}: {
  overview: { pages: PassportPageSummary[]; confirmed: number; required: number; progressPercent: number };
}) {
  const { t } = useTranslation();
  return (
    <>
      <Card>
        <CardHeader title={t("passportVig.index.routeProgress")} />
        <ProgressRing
          label={t("passportVig.index.requiredProgress")}
          value={overview.required ? overview.progressPercent : null}
          caption={t(
            overview.required === 0
              ? "learningRoute.state.optional"
              : overview.progressPercent === 100
                ? "learningRoute.state.complete"
                : "learningRoute.onTrack",
          )}
        />
        <p className="text-center text-sm text-muted-foreground">
          {t("passportVig.index.confirmedCount", {
            confirmed: overview.confirmed,
            required: overview.required,
          })}
        </p>
      </Card>
      <CompetencyBars pages={overview.pages} />
    </>
  );
}
